// SPEC-426 M2 A.2 (修复轮) — explicit review-phase decision (审查阶段显式化).
//
// Pure function, no external state. 提示 2 contract: requireReviewPhase(isBigChange, ops) —
// a big-change round (isBigChange=true OR ops.length ≥ BIG_OPS) MUST leave a screenshot+critique
// phase record on disk ('visual'); a small round is NOT forced ('skip' = 审查非强制).
//
// 'skip' is NOT a prohibition: shouldEnterLoop treats it as "ride the heuristics" — a new-design
// small-diff round still enters the loop (behavior 不回退). The previous {hasReference,
// isReplicate} signature was rejected as a semantic deviation (request_changes item 9): it
// consumed neither isBigChange nor ops and its decision table could never produce 'skip'.
//
// 'grounding' stays in the type for the replicate-with-reference branch: App.tsx marks it
// directly (SPEC-402 objective diff loop against the attached reference) — this function's
// decision table only ever produces 'visual' | 'skip'.

export type ReviewPhase = 'skip' | 'grounding' | 'visual';

/** Mirror of agentLoop.ts BIG_OPS (agentLoop imports this module's TYPE; keeping the constant
 * local avoids a value-level import cycle — sync by hand + PR review, same convention as the
 * intent heuristics mirrored between web/src/lib/agentLoop.ts and worker/src/agent.ts). */
const BIG_OPS = 8;

/**
 * 落盘前判定 (验收 4c 的函数断言): big-change 轮 → 'visual' (该轮必须落盘 screenshot+critique
 * 相位); 其余 → 'skip' (审查非强制, gate heuristics 继续生效)。
 */
export function requireReviewPhase(isBigChange: boolean, ops: { length: number }): ReviewPhase {
  return isBigChange || ops.length >= BIG_OPS ? 'visual' : 'skip';
}
